import * as React from 'react';
import { AppSetting } from 'dependencies/appsettings';
import { toJSON } from 'app/infrastructure/platform';

const shouldDisplayPlaceholders = () => AppSetting.ComponentDebug;

export const flexStyle =
  'd-lg-flex flex-wrap align-self-center align-content-around justify-content-between';

export const Dummy = (p: any) => {
  const placeHolderStyle = {
    border: '2px lightgray dashed',
    color: 'lightgray',
    padding: '5px',
    margin: '5px',
    opacity: 0.85,
    fontSize: '10px',
    fontStyle: 'italic'
  };

  const containerStyle = {
    borderBottom: '2px lightgray dashed',
    borderTop: '2px lightgray dashed',
    color: 'lightgray',
    fontSize: '10px',
    opacity: 1
  };

  const isContainer = p.children && p.children.length;

  if (shouldDisplayPlaceholders()) {
    return (
      <div
        // className = { flexStyle }
        key={p.sequence}
        style={isContainer ? containerStyle : placeHolderStyle}
      >
        {<label>{p.label && p.label.text}</label>}
        {<div>Placeholder for domain {p.componentId}</div>}
        {p.children}
      </div>
    );
  }

  return p.children || null;
};

export const JsonView = (p: any) => (
  <div key={p.sequence}>
    <label>{p.label && p.label.text}</label>
    <div>Placeholder for domain {p.componentId}</div>
    <span>{p.value && toJSON(p.value)}</span>
    <div>{p.children}</div>
  </div>
);

export const DebugPanel = (p: any) => (
  <div className="card">
    <div className="card-header">{p.label && p.label.text}</div>
    <div className="card-block">{p.children}</div>
  </div>
);
